<template>
    <div>
        <!-- <data-table :module-info="moduleInfo" :tb-columns="tbColumns" :toolbar-btns="listpageBtns" :on-list-data-before-load="onListDataBeforeLoad" :on-list-data-loaded="onListDataLoaded" :on-delete-successed="onDeleteSuccessed" /> -->
        <el-table :data="listData" border style="width: 100%">
            <el-table-column type="index" width="70" align="center" :label="$tx('fields.index', '序号')" />
            <el-table-column prop="flSubject" label="项目名称" />
            <el-table-column v-if="tableType == '1'" width="180" prop="wtUnit" align="center" label="委托单位" />
            <el-table-column v-if="tableType == '1'" width="120" prop="xmBusiType" align="center" label="业务类型">
                <template slot-scope="scope">
                    {{ getBusiType(scope.row.xmBusiType) }}
                </template>
            </el-table-column>
            <el-table-column v-if="tableType == '1'" width="120" prop="xmStatus" align="center" label="项目状态">
                <template slot-scope="scope">
                    {{ getStatus(scope.row.xmStatus) }}
                </template>
            </el-table-column>
            <el-table-column v-if="tableType == '2'" width="160" prop="flCreateDate" align="center" label="申请日期" />
            <el-table-column v-if="tableType == '2'" width="180" prop="wfNodeNames" align="center" label="流程状态" />
            <!-- <el-table-column prop="caozuo" label="操作" width="100" align="center">
                        <template slot-scope="scope">
                            <el-link type="primary" @click="selectRow(scope.row)">选择</el-link>
                        </template>
</el-table-column> -->
        </el-table>
        <div>
            <!-- <el-input v-model="searchVal" placeholder="请输入..." class="input-with-select" clearable>
                <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
            </el-input> -->
            <!--
<el-pagination v-if="listData.length > 0" style="margin: 10px" align="right" :current-page="params.pageNum"
    :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
    @size-change="handleSizeChange" @current-change="handleCurrentChange" /> -->
            <!-- <span slot="footer" class="dialog-footer">
                    <div class="dialog-footer-btn">
                        <el-button @click="handleClose">关 闭</el-button>
                    </div>
                </span> -->
        </div>
        <!-- <Basicform v-if="dialogFormVisible && showView == 'busiform'" :title="formTitle"
            :module-code="moduleInfo.moduleCode" :win-width="moduleInfo.winWidth" :append-to-body="true"
            :win-height="moduleInfo.winHeight" :toolbar-btns="busiformBtns"
            :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened"
            :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited">
            <template #default="slotProps">
                <busi-form :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
            </template>
</Basicform> -->
    </div>
</template>

<script>
import moment from 'moment'
export default {
    components: {},
    filters: {
        dateFormat(value) {
            if (value) {
                return moment(value).format('YYYY-MM-DD HH:mm')
            }
            return ''
        }
    },

    props: {
        vo: {
            type: Object,
            default: () => { }
        },
        wfInstance: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            dialogFormVisible: false,
            salaryAttachName: '',
            fileList: [],
            doing: false,
            yearNo: '', // 年度
            barchName: '', // 批次
            busiformBtns: [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: this.handleClose,
                    btnPermission: '',
                    btnType: ''
                },
                {
                    id: 'btn_save',
                    btnName: '保 存',
                    btnIcon: 'check',
                    btnClick: this.submitForm,
                    btnPermission: 'saveObject',
                    btnType: 'primary'
                }
            ],
            formTitle: '拟文模板',
            moduleInfo: {
                // listpageViewUrl: 'base.draftTemplate.list.vue',
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/base/draftTemplate/form.html',
                winWidth: 1000,
                delUrl: 'base/draftTemplate/delete',
                addNewUrl: 'base/draftTemplate/addNew',
                insertUrl: 'base/draftTemplate/insert',
                moduleCode: 'draftTemplate',
                listAdvSearchExpandPanel: 0,
                winHeight: 600,
                updateUrl: 'base/draftTemplate/update',
                listDataUrl: 'base/draftTemplate/listdata',
                getByIdUrl: 'base/draftTemplate/getById',
                listAdvSearchAllFields: 0
            },
            formVo: {},
            showView: 'listpage',
            listData: [],
            total: 0,
            currentPage: 1,
            params: {
                pageSize: 10,
                pageNum: 1,
                searchAndOr: '',
                // listpageViewUrl: this.moduleInfo.listpageViewUrl,
                urlsearch: ''
                // orderBy: 'actualStartTime desc'
            },
            loading: false,
            searchVal: '',
            activeName: 'first',
            tableType: ''
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$options.components['BusiForm'] = this.$loadComponent('#/dcontent/vuebusiform/W/base.draftTemplate.form.vue?sysCode=' + this.$route.meta.sysCode)
    },
    beforeDestroy() {
        this.$bus.off('openImportForm', this.openImportForm)
    },
    mounted() {
        if (this.vo.passenger.zjxmArchList.length > 0) {
            this.listData = this.vo.passenger.zjxmArchList
            this.tableType = '1'
        } else {
            this.listData = this.vo.passenger.zbxmlxList || []
            this.tableType = '2'
        }
    },
    methods: {

        getBusiType(type) {
            switch (type) {
                case 1:
                    return '司法鉴定'
                case 2:
                    return '评估报告'
                case 3:
                    return '工程量验收报告'
                case 4:
                    return '概算'
                case 5:
                    return '预算'
                case 7:
                    return '结算'
                case 8:
                    return '结算审核'
                case 9:
                    return '工程量清单'
                case 10:
                    return '预算控制价审核'
                case 11:
                    return '全过程'
                case 12:
                    return '招标控制价'
                default:
                    return ''
            }
        },
        getStatus(status) {
            if (status == 0) {
                return '未开始'
            } else if (status == 1) {
                return '进行中'
            } else if (status == 2) {
                return '已结束'
            }
        },
        down(url) {
            this.fileDownload(url)
        },
        openImportForm(type) {
            this.dialogFormVisible = true
            this.showView = type
            if (type == 'busiform') {
                this.$nextTick(function () {
                    this.$bus.emit('openBusiform', this.moduleInfo, null, 1, function (res) {
                        console.log('openBusiform', res)
                    })
                })
            } else {
                this.getData()
            }
        },
        handleClose() {
            this.dialogFormVisible = false
            this.listData = []
            this.formVo = {}
            this.searchVal = ''
            this.total = 0
        },
        getData() {
            this.loading = true
            const formData = new FormData()
            formData.append('pageSize', this.params.pageSize)
            formData.append('pageNum', this.params.pageNum)
            formData.append('listpageViewUrl', 'base.draftTemplate.list')
            // formData.append('orderBy', 'actualStartTime desc')
            // if (this.params.urlsearch) formData.append('urlsearch', this.params.urlsearch)
            // $scope.vo.wfName = this.wfInstance.wfName
            // $scope.vo.wfModule = this.wfInstance.module
            // $scope.vo.module = voCopy.module
            let urlsearch = `wfName:${this.wfInstance.wfName};wfModule:${this.wfInstance.module};module:${this.formVo.module ? this.formVo.module : ''}`
            formData.append('urlsearch', urlsearch)
            if (this.searchVal) {
                formData.append('searchAndOr', 'or')
                formData.append('searchMap[moduleName]', this.searchVal)
            } else {
                formData.append('searchAndOr', '')
            }
            this.$http({
                method: 'post',
                contentType: 'application/x-www-form-urlencoded',
                data: formData,
                url: this.moduleInfo.listDataUrl
            }).then((res) => {
                this.loading = false
                this.listData = res.body.pageInfo.list || []
                this.total = res.body.pageInfo.total || 0
                // this.$message.success('搜索成功！')
            })
        },
        selectRow(row) {
            // this.vo = row
            console.log('selectRow', row)
            // this.vo = JSON.parse(row.dataJson)
            // 触发父组件事件
            this.$emit('update', row) // 确保有传递参数
            this.handleClose()
        },
        submitForm() {
            this.formValidate(
                () => {
                    this.$http({
                        url: 'base/draftTemplate/insert',
                        method: 'POST',
                        data: this.formVo
                    }).then(async (res) => {
                        if (res.code === 'success') {
                            console.log(res)
                            this.$message.success(res.message)
                            this.$bus.emit('refreshListData')
                        } else {
                            this.$message.error(res.message)
                        }
                        this.handleClose()
                    })
                },
                null,
                this.canEdit
            )
        },
        closeDialog() {
            this.dialogFormVisible = false
            this.salaryAttachName = ''
            this.fileList = []
        },
        handleSizeChange(val) {
            this.params.pageNum = 1
            this.params.pageSize = val
            this.getData()
        },
        handleCurrentChange(val) {
            this.params.pageNum = val
            this.getData()
        },
        /**
         * 加载数据准备，qparams为查询参数对象，不需要返回值
         */
        onListDataBeforeLoad($scope, qparams) {
            // if (this.$route.meta.params && this.$route.meta.params.indexOf('dwadmin=1') !== -1) {
            //     if (qparams.urlsearch) {
            //         qparams.urlsearch += ';orgCode:' + $scope.loginUser.orgCode
            //     } else {
            //         qparams.urlsearch = 'orgCode:' + $scope.loginUser.orgCode
            //     }
            // }
            // if (this.moduleInfo.getByIdUrl.indexOf('logType') < 0) {
            //     if (this.moduleInfo.getByIdUrl.indexOf('?') < 0) {
            //         this.moduleInfo.getByIdUrl = this.moduleInfo.getByIdUrl + '?logType=' + qparams.logType
            //     } else {
            //         this.moduleInfo.getByIdUrl = this.moduleInfo.getByIdUrl + '&logType=' + qparams.logType
            //     }
            // }
            // if (process.env.NODE_ENV === 'development') console.log('sysLog listdata before load..')
            console.log($scope, qparams, 'role listdata before load..')
        },
        /**
         * 加载数据完成，pageInfo为包含查询结果的分页信息对象，不需要返回值
         */
        onListDataLoaded($scope, pageInfo) {
            // if (process.env.NODE_ENV === 'development') console.log('sysLog listdata loaded')
            console.log($scope, pageInfo, 'role listdata loaded')
        },
        /**
         * 表单打开检查，vo为已加载salaryInfo对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
         */
        onBasicFormBeforeOpen($scope, vo, defer) {
            const voCopy = JSON.parse(JSON.stringify(this.vo))
            voCopy.passenger = {}
            $scope.vo.wfName = this.wfInstance.wfName
            $scope.vo.wfModule = this.wfInstance.module
            $scope.vo.module = voCopy.module
            $scope.vo.moduleName = voCopy.flSubject
            $scope.vo.dataJson = JSON.stringify(voCopy)
            this.formVo = $scope.vo
            console.log('salaryInfo form before open', this.vo, $scope)
            defer.resolve(true)
        },
        /**
         * 表单打开完成，vo为已加载的salaryInfo对象，前端页面dom对象已完成初始化、已经呈现，不需要返回值
         */
        onBasicFormOpened($scope, vo) {
            console.log('salaryInfo form opened')
        },
        /**
         * 表单提交事件，可执行业务数据高级校验，vo为待提交的salaryInfo对象，校验成功：defer.resolve(true)，校验失败：defer.reject(reason)
         */
        onBasicFormBeforeSubmit($scope, vo, defer) {
            /* this.$confirm('您是否确认提交保存?', '确认操作', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning'
                      })
                          .then(() => {
                              defer.resolve(true)
                          })
                          .catch(err => {
                              defer.reject(err)
                          })*/

            console.log('salaryInfo form submit validation success')
            defer.resolve(true)
        },
        /**
         * 表单提交完成，vo为已保存成功的salaryInfo对象，窗口即将关闭，不需要返回值
         */
        onBasicFormSubmited($scope, vo) {
            console.log('salaryInfo form submited')
        }
    }
}
</script>

<style scoped lang="scss">
:deep(.el-dialog__body) {
    min-height: auto !important;
}

.input-with-select {
    margin-bottom: 15px;
}

.dialog-footer {
    .dialog-footer-btn {
        display: flex;
        justify-content: flex-end;
    }
}

.el-tooltip {
    /deep/ .el-upload.el-upload--text {
        width: 100%;
    }
}
</style>
